export const MANUAL_FORM_INITIALIZED = 'MANUAL_FORM/INITIALIZED'
export const FORM_REQUESTED = 'REQUEST/FORM'
export const FORM_FETCH_SUCCEEDED = 'SUCCEEDED/FORM/FETCH'
export const FORM_FETCH_FAILED = 'FAILED/FORM/FETCH'
export const FILL_FORM = 'FORM/FILL'
export const FORM_SUBMIT_START = 'STARTED/FORM/SUBMIT'
export const FORM_SUBMIT_STOP = 'STOPPED/FORM/SUBMIT'
export const WRITING_FORM_SUBMIT_REQUESTED = 'WRITING_REQUEST/FORM/SUBMIT'
export const FORM_SUBMIT_REQUESTED = 'REQUEST/FORM/SUBMIT'
export const FORM_SUBMIT_SUCCEEDED = 'SUCCEEDED/FORM/SUBMIT'
export const FORM_SUBMIT_FAILED = 'FAILED/FORM/SUBMIT'
export const FORM_LOADED = 'FORM/LOADED'
export const FORM_TITLE_FETCHED = 'FORM/TITLE/FETCHED'
export const FORM_AUTH_COMPLETE = 'FORM/AUTH/COMPLETE'
